import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Chip } from "@mui/material";
import MainApi from "../../../../services/mainApi.service";
import { IUBusRelationshipGroups } from "../../../../models/u-bus-relationship-group";
import { useMemo } from "react";
import { useAppSelector } from "../../../../store/store";

const U_BUS_RELATIONSHIP_GROUP_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusRelationshipGroup/";
const uBusRelationshipGroupService = new MainApi<IUBusRelationshipGroups>(
  U_BUS_RELATIONSHIP_GROUP_ROUTE,
);

const translationPath = "page.4uBus.relationships.relationshipGroup.";

const RelationshipGroupPage = () => {
  const navigate = useNavigate();

  const { extension } = useParams();

  const { t } = useTranslation();

  const currentPage = useAppSelector((state) => state.menu.actualPage?.name);

  const columns: GridColDef<IUBusRelationshipGroups>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "code",
      headerName: t(translationPath + "code") || "Code",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "description",
      headerName: t(translationPath + "description") || "Description",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "_4uBusAutomation",
      headerName: t(translationPath + "u_bus_automation") || "4uBus Automation",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 90,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={
              params.value
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={params.value ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IUBusRelationshipGroups>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const props = useMemo(
    () => ({
      ExtensionCode: extension,
    }),
    [extension],
  );

  return (
    <Table<IUBusRelationshipGroups>
      showDefaultMacroFilters={false}
      service={uBusRelationshipGroupService}
      serviceProps={props}
      columns={columns}
      title={currentPage ? t(currentPage) : t(translationPath + "relationship")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={
        t(translationPath + "add_relationship_group") ||
        "Add Relationship Group"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default RelationshipGroupPage;
